export const checkoutStore = {
    state: {
        paymentMethod: null,
        paymentDescription: null,
        paymentSubmitter: null,

        visaCheckoutIsReady: false,
        masterpassIsReady: false
    },

    requestCheckout() {
        if (this.state.paymentSubmitter) {
            this.state.paymentSubmitter();
        }
    },
}